var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIntermediatePointMoved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 39C20 38.4477 20.4477 38 21 38H40C40.5523 38 41 38.4477 41 39C41 39.5523 40.5523 40 40 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39C18 37.3431 19.3431 36 21 36C22.6569 36 24 37.3431 24 39C24 40.6569 22.6569 42 21 42C19.3431 42 18 40.6569 18 39Z",
    fill: "#2F2F32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39C19 37.8954 19.8954 37 21 37C22.1046 37 23 37.8954 23 39C23 40.1046 22.1046 41 21 41C19.8954 41 19 40.1046 19 39Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C20 38.4477 20.4477 38 21 38C21.5523 38 22 38.4477 22 39C22 39.5523 21.5523 40 21 40C20.4477 40 20 39.5523 20 39Z",
    fill: "#2D4422"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H22V27C22 27.5523 21.5523 28 21 28V28C20.4477 28 20 27.5523 20 27V3Z",
    fill: "#414146"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H40H40.4824C41.3205 0 42 0.679463 42 1.51762C42 1.83147 41.9027 2.1376 41.7215 2.39385L37.05 9L41.7215 15.6061C41.9027 15.8624 42 16.1685 42 16.4824C42 17.3205 41.3205 18 40.4824 18H40H20V0Z",
    fill: "#414146"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16H39.5508L34.6006 9L39.5508 2H22V16Z",
    fill: "#FF8F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIntermediatePointMoved);
export default __webpack_public_path__ + "static/media/map_intermediate_point_moved.a015107ec623b44dd8a58e2d94c08ec9.svg";
export { ForwardRef as ReactComponent };